export default "/images/780f0eaf38528adb396d6bd93747ff4c.avif";